import React, { useRef, useState } from "react";

const SpeakerOff = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M11 5 6 9H3v6h3l5 4V5z" fill="currentColor" />
    <path d="M17 9l4 6M21 9l-4 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export default function HeroVideo() {
  const videoRef = useRef(null);
  const [muted, setMuted] = useState(true);
  const [hover, setHover] = useState(false);

  const unmute = () => {
    const v = videoRef.current;
    if (!v) return;
    v.muted = false;
    v.volume = 0.6;
    const p = v.play();
    if (p && typeof p.catch === "function") p.catch(() => {});
    setMuted(false);
  };

  return (
    <>
      <video
        ref={videoRef}
        src="/hero.mp4"
        autoPlay
        loop
        muted
        playsInline
        preload="auto"
        aria-label="Ego Blockchain"
        style={{
          position: "absolute",
          inset: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
        }}
      />

      {muted && (
        <button
          type="button"
          onClick={unmute}
          onMouseEnter={() => setHover(true)}
          onMouseLeave={() => setHover(false)}
          aria-label="Click to unmute"
          style={{
            position: "absolute",
            top: "48%",
            left: "50%",
            transform: `translate(-50%, -50%) scale(${hover ? 1.04 : 1})`,
            zIndex: 5,
            display: "inline-flex",
            alignItems: "center",
            gap: 12,
            padding: "14px 30px",
            borderRadius: 999,
            border: `1px solid rgba(255,255,255,${hover ? 0.55 : 0.35})`,
            background: `rgba(0,0,0,${hover ? 0.5 : 0.35})`,
            backdropFilter: "blur(10px)",
            WebkitBackdropFilter: "blur(10px)",
            color: "#fff",
            fontSize: 19,
            fontWeight: 500,
            letterSpacing: "0.01em",
            lineHeight: 1,
            whiteSpace: "nowrap",
            cursor: "pointer",
            transition:
              "background 180ms ease, border-color 180ms ease, transform 180ms ease",
          }}
        >
          <SpeakerOff />
          Click to unmute
        </button>
      )}
    </>
  );
}
